// extracted by mini-css-extract-plugin
export default {"activedfdf":"Navbar_activedfdf__TNDLz","active":"Navbar_active__o1Ok7"};